import BaseModalForm from 'components/BaseModalForm';
import _ from 'lodash';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import { BASE_SEVERITIES } from 'views/Findings/Constants';

const ROOT_PROPERTIES = ["apiToken", "name", "enabled", "url", "notificationLevels"];

const AlertConfigFormPopup = React.forwardRef(function AlertConfigFormPopup(props, ref) {
	const success = useRef(false);
	const [initialValues] = useState(() => {
		return {
			..._.pick(props.data, ROOT_PROPERTIES),
			alerts: props.data?.notificationLevels?.alerts || BASE_SEVERITIES,
		}
	});
	const editId = props.data?.id;

	const onOk = useCallback((values) => {
		const data = {
			id: editId,
			..._.pick(values, ROOT_PROPERTIES),
			notificationLevels: {
				alerts: values.alerts
			},
			enabled: _.isUndefined(initialValues.enabled) ? true : initialValues.enabled
		}
		return ToolsIntegrationsAPI.createOrupdateAlertIntegration(data).promise.then(() => success.current = true);
	}, [editId, initialValues.enabled, success]);

	const fields = useMemo(() => {
		const fields = [{
			name: "name",
			label: "Configuration Name",
			required: true,
			props: {
				autoFocus: true
			}
		}, {
			name: "url",
			label: "URL",
			required: true,
			rules: [urlRegexValidator()]
		}, {
			label: "API Token",
			name: "apiToken",
			type: FieldTypes.PASSWORD,
			required: true,
		}, {
			name: "alerts",
			label: "Alert Levels",
			type: FieldTypes.CHECKBOX_GROUP,
			labelAlign: "left",
			options: BASE_SEVERITIES,
			required: true,
		}];

		return fields;
	}, []);

	return (
		<BaseModalForm
			ref={ref}
			title={`${editId ? "Edit" : "Add"} Configuration`}
			onOk={onOk}
			fields={fields}
			initialValues={initialValues}
			afterClose={() => props.afterClose(success.current)}
		/>
	)
})

export default AlertConfigFormPopup;